import { render } from "./ProgramaSemilleroVentasArea.vue?vue&type=template&id=112970dc"
import script from "./ProgramaSemilleroVentasArea.vue?vue&type=script&lang=js"
export * from "./ProgramaSemilleroVentasArea.vue?vue&type=script&lang=js"

import "./ProgramaSemilleroVentasArea.vue?vue&type=style&index=0&id=112970dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__